import { RiHome2Line } from "@itandi/itandi-bb-ui";
import type { Deal } from "~/models/Deal";
import { formatDate } from "~/utils/DateUtil";
import Styles from "../../../../../../common/deals/new/block/Block.module.scss";
import { RoomBlockProperty } from "./RoomBlockProperty";

type Props = { deal: Deal };

export function RoomBlock({ deal }: Props) {
	return (
		<div className={Styles.Block}>
			<div className={Styles.BlockCaptionWrapper}>
				<div className={Styles.BlockCaption}>
					<span className={Styles.BlockIconWrapper}>
						<RiHome2Line className={Styles.BlockIcon} />
					</span>
					<span className={Styles.BlockCaptionLabel}>物件情報</span>
				</div>
			</div>
			<div className={Styles.BlockForms}>
				<RoomBlockProperty deal={deal} />
				<div className={Styles.FormRow}>
					<div className={Styles.FormLabel}>
						<span className={Styles.FormLabelText}>エレベーターの有無</span>
					</div>
					<div className={Styles.FormContent}>
						<div className={Styles.InputRadioGroup}>
							{deal.enableElevator ? "あり" : "なし"}
						</div>
					</div>
				</div>
				<div className={Styles.FormRow}>
					<div className={Styles.FormLabel}>
						<span className={Styles.FormLabelText}>オートロックの有無</span>
					</div>
					<div className={Styles.FormContent}>
						<div className={Styles.InputRadioGroup}>
							{deal.enableAutoLock ? "あり" : "なし"}
						</div>
					</div>
				</div>
				<div className={Styles.FormRow}>
					<div className={Styles.FormLabel}>
						<span className={Styles.FormLabelText}>鍵の置き場所</span>
					</div>
					<div className={Styles.FormContent}>
						<div className={Styles.InputWrapper}>
							{deal.placeKeyStoring ?? ""}
						</div>
					</div>
				</div>
				<div className={Styles.FormRow}>
					<div className={Styles.FormLabel}>
						<span className={Styles.FormLabelText}>無償利用が可能な駐車場</span>
					</div>
					<div className={Styles.FormContent}>
						<div className={Styles.InputWrapper}>{deal.freeParking ?? ""}</div>
					</div>
				</div>
				<div className={Styles.FormRow}>
					<div className={Styles.FormLabel}>
						<span className={Styles.FormLabelText}>入居予定日</span>
					</div>
					<div className={Styles.FormContent}>
						<div>{formatDate(deal.preferredDate)}</div>
					</div>
				</div>
			</div>
		</div>
	);
}
